import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AppIpInfoService {
	constructor() {}

	getCountryCodeByUserIp() {
		// we use fetch because angular http client influenced by app interceptors
		return fetch('https://geolocation-db.com/json/').then(response => response.json());
	}
}
